import React, { Component } from 'react';
import GeckoCardWrapper from './card-wrapper/card-wrapper';
import GeckoCardBody from './card-body/card-body';

class GeckoCard extends Component {

    render() {
		return (
            <GeckoCardWrapper>
            
            	<GeckoCardBody {...this.props}>

                	{this.props.children}

                </GeckoCardBody>

            </GeckoCardWrapper>
        );
    }
}

export default GeckoCard;